import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/content/content.styles.ts
var content_styles_default = r` fadv-content { font-family: var(--sl-font-sans); display: block; } .content--fixed, .content--fixed > div { height: 100%; } `;

export {
  content_styles_default
};
